<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<h2 class="fm-title">Acknowledgements</h2>
<p class="noindent">A book of this nature would not have been possible without the help of many people and organisations too numerous to individually mention. I am indebted to many for providing photographs and information - first-hand and anecdotal - for this story, but in some cases it has not been possible to identify the original photographer or information source and so credits are given in the appropriate places to the immediate supplier. If any of the pictures have not been correctly credited, please accept my apologies.</p>
<p class="noindentf">I would however, like to offer my special thanks the Fellows, Members and Associates of the Worldwide Society of Civil Aviation Enthusiasts (WSCAE) - many of whom work in the global aviation industry as flight or ground crew or indeed ‘on the spanners’ - for letting me have free access to their collections of images and information, including Dee Diddley (Ireland/Eire), Ameen Yasheed (Middle East), Wan Hunglo and Tsai Ing-Wen, (China and Far East), John Hamlin, Bob Lehat, Kirk Smeeton, Ian Frimston, Hugh Jampton, Peter Clegg, Matt Black, Alan ‘Al’ Conberry, David Lee, (all UK and Europe), Carrie Åberg (Scandanavia), Temil Sokhet (Asia), Simon Peters, Robin Banks, Rick O’Shea, Adam Brookes, Emma Dayle, Dr Harry Friedman, (USA, Caribbean and Canada) Trymore Simango, Kim Bolton and Phil McCrackin (Africa and Europe) Bill Armstrong, Autair, and Edward ‘Ed’ Posey, Court Line Aviation and Richard Vandervord.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Acknowledgements.vue?7c5d89ae